module.exports = __webpack_public_path__ + "img/p-one-step-25.0532bcc1.png";